
<div class="labelable">
  <label :class="[isPlaceholder, {required: isRequired}]"
         tabindex="0"
         @click="enableEditMode"
         @keydown.enter="enableEditMode"
         v-show="!isEditMode">{{labelTitle}}<required-indicator v-if="isRequired" /></label>
  <slot></slot>
  <expandable-textarea ref="textareaComponent"
                       :isShown="isEditMode"
                       @mousedown.stop
                       @blur="blur"
                       @paste="$emit('paste', $event)"
                       v-model.sync="localValue"
                       name="label_title"
                       v-on:keydown:enter="enter"
                       expandsHorizontally
                       :is-disabled="!canConfigure"
                       :placeholder="placeholder"></expandable-textarea>

</div>
